import React from "react";
import TextInput from "../TextInput";

export default class AdvanceTransferPayment extends React.Component {

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (this.props.option && (this.props.option.amount === undefined || this.props.option.amount === null || this.props.option.amount === "")) {
            this.props.setFieldValue(String(this.props.optionIndex) + ".amount", Math.max(0, this.props.total - (this.props.cost + this.props.rounding) - (this.props.overpay > 0 ? this.props.overpay : 0)));
        }
    }

    render() {
        const amount = this.props.option.amount;
        return (
            <div className="payment advancetransfer-payment">
                <TextInput
                    type="number"
                    name="amount"
                    label={"Fizetendő"}
                    value={amount}
                    saveChanges={(name, value) => {
                        value = parseFloat(value || "0");
                        this.props.setFieldValue(String(this.props.optionIndex) + ".amount", value);
                    }}/>
            </div>
        );
    }
}